<template>
  <div class="mt-10 sm:mt-16 print:hidden">
    <button class="mb-8 underline hover:no-underline" @click="cancel()">
      {{ canceltext }}
    </button>

    <div :class="{ 'sm:w-full': fullWidth, 'sm:w-1/2': !fullWidth }">
      <div class="flex items-center">
        <div>
          <h1 class="text-2xl font-bold">
            {{ title }}
          </h1>
          <p
            v-if="description"
            class="text-gray-700 text-sm leading-loose my-1"
          >
            {{ description }}
          </p>
        </div>
      </div>
      <hr class="my-4 border-t border-gray-400" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTop',
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    canceltext: {
      type: String,
      default: null
    },
    cancelurl: {
      type: String,
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    cancel() {
      this.$router.push(this.cancelurl);
      this.scrollToTop();
    }
  }
};
</script>
